import React from 'react';
import SplitSVG from 'assets/svg/split.svg';

const Split = () => {
  return (
    <img
      src={SplitSVG}
      alt="split"
      width="22px"
      height="22px"
      style={{ marginRight: 5 }}
    />
  );
};

export default Split;
